import React from 'react';
import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalFooter,
	ModalCloseButton,
	Button,
	Text,
	Box,
	List,
	ListItem,
	Textarea,
} from '@chakra-ui/react';
import { Sample } from '../../../utils/interfaces';

interface SampleDetailsModalProps {
	isOpen: boolean;
	onClose: () => void;
	sample: Sample | null;
}

const SampleDetailsModal: React.FC<SampleDetailsModalProps> = ({ isOpen, onClose, sample }) => {
	if (!sample) {
		return null;
	}

	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Sample Details</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<List spacing={2}>
						<ListItem>
							<Text fontWeight="bold">Name:</Text> {sample.name}
						</ListItem>
						<ListItem>
							<Text fontWeight="bold">Type:</Text> {sample.type}
						</ListItem>
						<ListItem>
							<Text fontWeight="bold">Languages:</Text> {sample.languages}
						</ListItem>
						<ListItem>
							<Text fontWeight="bold">Audio:</Text>
							<Box mt={1}>
								<audio
									controls
									src={sample.audioFileUrl}
									style={{ width: '100%' }}
								/>
							</Box>
						</ListItem>
						<ListItem alignItems="flex-start">
							<Text fontWeight="bold" mb={1}>
								Ground Truth File:
							</Text>
							{sample.groundtruth && (
								<>
									<Textarea
										value={sample.groundtruth}
										isReadOnly
										variant="filled"
										size="md"
										resize="vertical"
										minH="60px"
										mb={2}
									/>
								</>
							)}
						</ListItem>
					</List>
				</ModalBody>
				<ModalFooter>
					<Button onClick={onClose}>Close</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default SampleDetailsModal;
